import Axios from 'axios';

export default {
  getChargesBasedOnTypes() {
    return Axios.get('/admin/enums/charges-rules/charges-based-ons')
      .then(({ data }) => data);
  },
  getOriginTypes() {
    return Axios.get('/admin/enums/billings/origins')
      .then(({ data }) => data);
  },
  getStartRuleTypes() {
    return Axios.get('/admin/enums/contract-creation-rules/start-rules')
      .then(({ data }) => data);
  },
  getAdmissionAmountTypes() {
    return Axios.get('/admin/enums/admission-payment-rules/amount-types')
      .then(({ data }) => data);
  },
  getBillAdjustmentTypes() {
    return Axios.get('/admin/enums/bill-adjustment-rules/adjustment-types')
      .then(({ data }) => data);
  },
  getBillAdjustmentThresholdTypes() {
    return Axios.get('/admin/enums/bill-adjustment-rules/threshold-types')
      .then(({ data }) => data);
  },
  getDaysRelativeToTypes() {
    return Axios.get('/admin/enums/advanced-payment-discount-rules/days-relative-tos')
      .then(({ data }) => data);
  },
  getDaysKindTypes() {
    return Axios.get('/admin/enums/advanced-payment-discount-rules/days-kinds')
      .then(({ data }) => data);
  },
  getAmountTypes() {
    return Axios.get('/admin/enums/advanced-payment-discount-rules/amount-types')
      .then(({ data }) => data);
  },
  getShiftTypes() {
    return Axios.get('/admin/shifts')
      .then(({ data }) => data.map(({ id, name }) => ({ value: id, label: name })));
  },
  getKindTypes() {
    return Axios.get('/admin/kinds')
      .then(({ data }) => data.map(({ id, name }) => ({ value: id, label: name })));
  },
  getLevelTypes() {
    return Axios.get('/admin/levels')
      .then(({ data }) => data.map(({ id, name }) => ({ value: id, label: name })));
  },
};
